import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SrText from 'client/components/SrText';

import './BulkResultBanner.less';

export const BANNER_VARIANT_SUCCESS = 'success';
export const BANNER_VARIANT_WARNING = 'warning';
export const BANNER_VARIANT_ERROR = 'error';

const BANNER_VARIANTS = [BANNER_VARIANT_SUCCESS, BANNER_VARIANT_WARNING, BANNER_VARIANT_ERROR];

const SUCCESS_AUTO_DISMISS_MS = 5000;

const formatReasons = (reasons) => {
  if (!reasons || reasons.length === 0) return '';
  return reasons.join('; ');
};

const buildMessage = ({ variant, successCount, failedCount, reasons }) => {
  if (variant === BANNER_VARIANT_SUCCESS) {
    const noun = successCount === 1 ? 'address' : 'addresses';
    return `${successCount} ${noun} ignored.`;
  }
  if (variant === BANNER_VARIANT_WARNING) {
    const detail = formatReasons(reasons);
    const suffix = detail ? `: ${detail}` : '';
    return `${successCount} ignored. ${failedCount} could not be ignored${suffix}.`;
  }
  // error
  return 'Could not ignore addresses. Please try again.';
};

const BulkResultBanner = ({ variant, successCount, failedCount, reasons, onClose }) => {
  useEffect(() => {
    if (variant !== BANNER_VARIANT_SUCCESS) return undefined;
    const timer = setTimeout(onClose, SUCCESS_AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [variant, onClose]);

  const message = buildMessage({ variant, successCount, failedCount, reasons });

  return (
    <div styleName={classNames('BulkResultBanner', variant)} role="status">
      <div styleName="message">
        <SrText font="greycliff" weight="600" size="14">
          {message}
        </SrText>
      </div>
      <button type="button" styleName="close" onClick={onClose} aria-label="Dismiss notification">
        ×
      </button>
    </div>
  );
};

BulkResultBanner.propTypes = {
  variant: PropTypes.oneOf(BANNER_VARIANTS).isRequired,
  successCount: PropTypes.number,
  failedCount: PropTypes.number,
  reasons: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
};

BulkResultBanner.defaultProps = {
  successCount: 0,
  failedCount: 0,
  reasons: [],
};

BulkResultBanner.displayName = 'BulkResultBanner';

export default BulkResultBanner;
